/**
 * Display constants for the staff preference screens. The values themselves live on the server (see
 * `useStaffPreferences` in `workspace-api.ts` and the shared contracts in `@mybusinessmate/schema`).
 */
import type { Weekday } from '@mybusinessmate/schema';

export type { Weekday };

export const WEEKDAYS: { id: Weekday; label: string }[] = [
  { id: 'mon', label: 'Mon' },
  { id: 'tue', label: 'Tue' },
  { id: 'wed', label: 'Wed' },
  { id: 'thu', label: 'Thu' },
  { id: 'fri', label: 'Fri' },
  { id: 'sat', label: 'Sat' },
  { id: 'sun', label: 'Sun' },
];

export const ALERTS = [
  { id: 'taskAdded', title: 'You’re added to a task', hint: 'Includes tasks a lead hands to you', locked: false },
  { id: 'draftReview', title: 'A draft needs your review', hint: 'Leads and above', locked: false },
  { id: 'draftDecision', title: 'Your draft was approved or sent back', locked: false },
  { id: 'clientMessage', title: 'New message from a client', locked: false },
  { id: 'mention', title: 'Someone mentions you', locked: false },
  { id: 'meeting', title: 'Meeting requested or changed', locked: false },
  { id: 'taskDue', title: 'Task due tomorrow', locked: false },
  { id: 'payment', title: 'Payment failed or plan cancelled', hint: 'Admins and account managers', locked: false },
  {
    id: 'security',
    title: 'New sign-in or security change',
    hint: 'Always on. These keep your account safe.',
    locked: true,
  },
] as const;

/** "21:00" -> "9:00 PM". */
export function formatClock(hhmm: string): string {
  const [h = '0', m = '00'] = hhmm.split(':');
  const hour = Number(h);
  return `${hour % 12 === 0 ? 12 : hour % 12}:${m} ${hour < 12 ? 'AM' : 'PM'}`;
}

export const CLOCK_OPTIONS: { value: string; label: string }[] = Array.from({ length: 48 }, (_, i) => {
  const value = `${String(Math.floor(i / 2)).padStart(2, '0')}:${i % 2 ? '30' : '00'}`;
  return { value, label: formatClock(value) };
});
